export var EnumFormTypes;
(function (EnumFormTypes) {
    EnumFormTypes["input"] = "input";
    EnumFormTypes["audio"] = "audio";
    EnumFormTypes["select"] = "select";
    EnumFormTypes["cascader"] = "cascader";
    EnumFormTypes["checkbox"] = "checkbox";
    EnumFormTypes["inputType"] = "textarea";
})(EnumFormTypes || (EnumFormTypes = {}));
